import React from 'react';
export function FAQ() {
  return <section className="py-12" data-id="element-51">
      <div className="max-w-3xl mx-auto" data-id="element-52">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-green-800 mb-8" data-id="element-53">
          FAQs
        </h2>
        <div className="space-y-6" data-id="element-54">
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-55">
            <h3 className="text-xl font-bold mb-2" data-id="element-56">
              Q: Will Aya Caps make me hallucinate?
            </h3>
            <p className="text-lg" data-id="element-57">
              No. Aya Caps do not contain any psychoactive components. They are
              non-intoxicating and designed for gentle, daily support.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-58">
            <h3 className="text-xl font-bold mb-2" data-id="element-59">
              Q: Are they legal in the U.S.?
            </h3>
            <p className="text-lg" data-id="element-60">
              Yes, Aya Caps are legal in all states except Louisiana. Always
              follow local laws and consult your physician.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-61">
            <h3 className="text-xl font-bold mb-2" data-id="element-62">
              Q: What if I'm on medication?
            </h3>
            <p className="text-lg" data-id="element-63">
              Aya Caps contain natural MAO-A alkaloids, which may interact with
              certain medications or foods. Please consult your healthcare
              provider before use.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-64">
            <h3 className="text-xl font-bold mb-2" data-id="element-65">
              Q: How long until I feel something?
            </h3>
            <p className="text-lg" data-id="element-66">
              Some users notice a shift within days. Others feel it more
              gradually over a few weeks. Effects are often subtle — more like a
              softening or clearing — rather than dramatic.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-67">
            <h3 className="text-xl font-bold mb-2" data-id="element-68">Q: Is there a guarantee?</h3>
            <p className="text-lg" data-id="element-69">
              Yes. We want you to feel confident trying Aya Caps. If you're not
              satisfied, reach out to our support team within 30 days for a
              refund.
            </p>
          </div>
        </div>
        <div className="mt-10 text-center" data-id="element-70">
          <a href="#pricing-section" className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-lg text-xl transition duration-300 shadow-lg inline-block" onClick={e => {
          e.preventDefault();
          document.getElementById('pricing-section')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} data-id="element-71">
            Try Aya Caps Today
          </a>
        </div>
        <div className="mt-10 text-sm text-gray-600 bg-gray-100 p-4 rounded-lg" data-id="element-72">
          <p data-id="element-73">
            † This product contains Banisteriopsis caapi, which is a natural
            Monoamine Oxidase Inhibitor (MAOI). Before taking this supplement,
            please consult with your healthcare provider, especially if you are
            taking any other medications, as MAOIs can interact with certain
            drugs, including antidepressants and certain pain medications. Do
            not use this supplement if you are taking psychiatric medications or
            have a history of mental health disorders unless under the direct
            supervision of a qualified healthcare professional.
          </p>
          <p className="mt-2" data-id="element-74">
            These statements have not been evaluated by the Food and Drug
            Administration. This product is not intended to diagnose, treat,
            cure, or prevent any disease.
          </p>
        </div>
      </div>
    </section>;
}